<!-- Component used to display a single article -->
<template>
<!-- hide abstract if the table is shown -->
  <div class="showImages"
       :class='{ hideImages: store.state.showResultsTable }'>
    <button
      class="btn back-to-results"
      @click="
        store.state.selectedArticle = null;
        store.state.showResultsTable = true;
      "
    >
      Back to Results
    </button>
    <div class="article-single">
      <h3>{{ article.Title }}</h3>
      <p>{{ article.Citation }}. <a :href="article.DOI" target="_blank">{{ article.DOI }}</a>
</p>

     <!--  <p>{{ article.Author }} - {{ article["Issue Date"] }}</p> -->
      <br />
      <p>{{ article["Conference Name"] }}</p>
      <hr class="mb-4" />
      <h4 style="font-weight: bold">Abstract</h4>
      <p>{{ article.Abstract }}</p>
      <p>Terms: {{ article.LowLevel }}</p>
      <p>Main Topics: {{ article.MidLevel }}</p>
      <div class="wp-block-buttons">
        <div class="wp-block-button">
          <a
            class="wp-block-button__link has-background"
            :href="article.DOI"
            style="background-color: #33a6b2; border-radius: 1px"
            target="_blank"
            >Go to Article</a
          >
        </div>
      </div>
    </div>
    <div v-if="store.state.relatedArticles">
      <hr />
      <h4>Related Articles</h4>
      <p>The following listing represents the 20 most related articles based on how well their abstracts and keywords match this record.</p>
      <RelatedArticles />
      <p>
       * deemed most relevant to the AREA Research Agenda
      </p>
    </div>
  </div>
</template>
<script>
import { store } from "@/store";
import RelatedArticles from "./Related";
export default {
  name: "Article",
  components: { RelatedArticles },
  data() {
    return {
      store,
      article: store.state.selectedArticle,
      articles: store.state.allArticles
    };
  },
  methods: {
    refresh_article() {
      this.$forceUpdate();
    }
  }
};
</script>
<style scoped>
.related-article-title {
  cursor: pointer;
  margin-bottom: 5px;
  list-style-type: none;
}
</style>
